import React, { useEffect, useState, useContext, useRef } from "react";
import ReactDOM from "react-dom";
import { Buffer } from "buffer";
import { countries } from "../../../utils/functions/constants";
import searchCep from "../../../utils/functions/searchCep";
import { lumCalc } from "../../../utils/functions/lumCalc";
import { getBodyRequest } from "../../../utils/functions/payloadValidation";
import { useParams } from "react-router-dom";
import serverProvider from "../../../providers/serverProvider";
import Loader from "../../../components/Loader/Loader";
import NotFound from "../../../components/notFound/notFound";
import AuthSetup from "../../../components/AuthSetup/AuthSetup";
import SelectOption from "../../../components/SelectOption";
import AuthChallenger from "../../../components/AuthChallenger/AuthChallenger";
import CircleLoader from "../../../components/CircleLoader/CircleLoader";
import ReCAPTCHA from "react-google-recaptcha";
import { FullPageLoaderContext } from "../../../contexts/fullPageLoader";
import { PaymentPageLoaderContext } from "../../../contexts/PaymentPageLoader";
import { InformationPopUpContext } from "../../../contexts/informationPopUp";
import brasil from "../../../assets/images/brasil.png";
import alert from "../../../assets/images/alert.svg";
import pixImg from "../../../assets/images/pix-banco-central.svg";
import compraSeguraLogo from "../../../assets/images/compra_segura.svg";
import infoQuestion from "../../../assets/images/infoQuestion.svg";
import logoImg from "../../../assets/images/logo.png";
import ELO from "../../../assets/images/bandeiras/ELO.png";
import HIPERCARD from "../../../assets/images/bandeiras/HIPERCARD.png";
import MASTER from "../../../assets/images/bandeiras/MASTER.png";
import VISA from "../../../assets/images/bandeiras/VISA.png";
import AMEX from "../../../assets/images/bandeiras/AMEX.png";
import {
  BoxSelectCheckoutLP,
  CheckoutLPBrasil,
  CheckoutLPContainer,
  CheckoutLPFlag,
  CheckoutTestMode,
  CheckoutTypeFlags,
  DeliveryAddress,
  DeliveryType,
  FlagsContainer,
  FlagsContainerRow,
  FormPayment,
  FormPaymentType,
  HeaderInfoContents,
  ImgFlag,
  InfoContents,
  InputCheckoutLP,
  LogoImg,
  PurchaseSummary,
  SelectCheckoutLP,
  CheckoutAllowTerms,
  TitleProducts,
  ConfirmBtn,
  BoxProductValues,
  ProductDescription,
  FormBillingAddress,
  LineDivider,
  PurchaseDetails,
  CheckoutForm,
  LoaderStyle,
  SelectCheckoutPayment,
  InputFormPayment,
  PixImg,
  DivPix,
  PurchaseCheckout,
  DivLogoImg,
  LogoMrImg,
  Divbackground,
  Address,
  CountryCepContainer,
  ResponsibleReceiving,
  ReceiverInformation,
  CardContainer,
  Identification,
  CheckoutInformation,
} from "./LinkStyles";
import SeloSecurity from "../../../components/SeloSecurity/SeloSecurity";
import AlertImage from "../../../components/AlertImage";

const getKey = () => Math.random().toString(36).substring(2);

// Retorna a quantidade de dias de vendedor de um determinado cliente
const getDaysSeller = (initial, today) => {
  const number_days = (new Date(today) - new Date(initial)) / (1000 * 60 * 60 * 24);
  if (Number.isInteger(number_days) && number_days >= 0) {
    return `${number_days} Dias`;
  } else {
    return "";
  }
};

// Se existir o campo payment no checkout, retorna os campos do parcelamento
const checkoutInstallment = (payment) => {
  const installments = payment
    ? {
        max_installments: payment["max_installments"],
        max_installments_with_interest: payment["max_installments_with_interest"],
      }
    : {};

  const checkout_installments = Object.keys(installments).reduce((acc, cur) => {
    return installments[cur] ? { ...acc, [cur]: installments[cur] } : acc;
  }, {});

  return checkout_installments;
};

// Retorna o tipo da parcela com base na parametrização recebendo o nº da parc.
const getInstallmentConfigType = (number, installments) => {
  const type_name = {
    installment_type_1: "(sem juros)",
    installment_type_2: "(com juros)",
  };

  const installment = `installment_${number}`;
  const installment_type = `installment_type_${installments[installment]}`;

  return type_name[installment_type] || "";
};

// Retorna o tipo da parcela com base na parametrização do Checkout
const getInstallmentCheckoutType = (number, installments) => {
  if (installments["max_installments"] && !installments["max_installments_with_interest"]) {
    return "(sem juros)";
  }

  if (!installments["max_installments"] && installments["max_installments_with_interest"]) {
    return "(com juros)";
  }

  if (installments["max_installments"] && installments["max_installments_with_interest"]) {
    if (number <= installments["max_installments"]) {
      return "(sem juros)";
    } else {
      return "(com juros)";
    }
  }
};

// Retorna os total de juros da parcela escolhida
const getInterestValue = (interest_amount, amount) => {
  return Number(interest_amount) - Number(amount);
};

// Cria um array contendo apenas os dados a serem mostrados pelo select
const arrayParcel = (value, config_installment, checkout_installment) => {
  if (!config_installment) return "";
  if (value.constructor !== Array) return "";

  const exists_checkout_installment = checkoutInstallment(checkout_installment);
  return value.map((item) => {
    // Se for agendamento, é sem juros
    const arr_type = checkout_installment?.recurrent_payment
      ? "(sem juros)"
      : Object.keys(exists_checkout_installment).length === 0
        ? getInstallmentConfigType(item.parcel_number, config_installment)
        : getInstallmentCheckoutType(item.parcel_number, exists_checkout_installment);

    return `${item.parcel_number}X de ${toMoneyFormat(String(item.installment))} ${arr_type}`;
  });
};

// Gera máscara para cpf/cnpj
const formatCpfCnpj = (value) => {
  if (value) {
    const cpfCnpj = value.replace(/\D/g, "");
    if (cpfCnpj.length <= 11) {
      return cpfCnpj
        .replace(/(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/, "$1.$2.$3-$4")
        .replace(/(\.\.-|\.-|-)$/g, "");
    } else {
      return cpfCnpj
        .replace(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/, "$1.$2.$3/$4-$5")
        .replace(/(\.\.\/-|\.\/-|\/-|-)$/g, "");
    }
  } else {
    return "";
  }
};

// Gera máscara para telefone
const formatPhoneNumber = (value) => {
  if (value) {
    const phone = value.replace(/\D/g, "");
    // Replace no final apaga tudo que termina em caractere
    return phone.replace(/(\d{0,2})(\d{0,5})(\d{0,4})/, "($1) $2-$3").replace(/(\D+)$/g, "");
  } else {
    return "";
  }
};

// Gera máscara para dinheiro com número em string's
const toMoneyFormat = (value) => {
  return Number(value / 100).toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
  });
};

// Retorna o subtotal do resumo do pedido
const subtotalValue = (checkout) =>
  checkout.cart.items.reduce((acc, cur) => {
    const quantity_value = !cur.quantity || cur.quantity < 0 ? 1 : cur.quantity;
    return acc + Number(cur.product_price) * quantity_value;
  }, 0);

const discountValue = (discount) =>
  !discount.cart.discount
    ? 0
    : discount.cart.discount.type === "amount"
      ? discount.cart.discount.value
      : subtotalValue(discount) * (discount.cart.discount.value / 100);

// Função para desconto do tipo Pagamento com PIX
const discountWithPix = (amount, discount) => {
  const new_value = amount * (discount / 100);
  // Operação = 10% de 5658
  // resultado absoluto = 565.800000001
  // math.round() = 566
  return Math.round(new_value);
};

// Gera um intervalo de espera
const sleep = (ms) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

// Retorna o número associado à bandeira do E-sitef
const getAuthorizerId = (flag) => {
  const authorizer = {
    VISA: "1",
    MASTER: "2",
    AMEX: "3",
    HIPERCARD: "5",
    ELO: "41",
  };
  return authorizer[flag];
};

// Retorna o tipo de pagamento do objeto que armazena o estado
const getPaymentValue = (type) => {
  const payment = {
    "Cartão de crédito": "credCard",
    Pix: "pix",
  };
  return payment[type];
};

// Retona um objeto indicado se a transação terá ou não antifraud e autenticação
const getTransactionMethod = (arr_methods, amount) => {
  // Se não tiver nada no transactions ou estiver vazio, não retorna nenhum método
  if (!arr_methods || arr_methods.length === 0) return { auth: false, antifraud: false };

  const transaction_type = {
    0: { auth: false, antifraud: false },
    1: { auth: false, antifraud: true },
    2: { auth: true, antifraud: true },
    3: { auth: true, antifraud: false },
  };

  const type = arr_methods.reduce((acc, cur) => {
    if (Number(amount) >= cur.value) return cur.type;
    return acc;
  }, 0);

  return transaction_type[type];
};

// Retorna as dimensões do pagamento com desafio
const getiFrameDimensions = (challengeWindowSize) => {
  const sizes = {
    size_01: { width: "250", height: "400" },
    size_02: { width: "390", height: "400" },
    size_03: { width: "500", height: "600" },
    size_04: { width: "600", height: "400" },
    size_05: { width: "100%", height: "100%" },
  };

  const size = `size_${challengeWindowSize}`;
  return sizes[size] || {};
};

// Busca o menor preço dos serviços de frete
const initializeShipping = (values) => {
  return values.reduce((acc, cur, i) => {
    if (i === 0) return i;

    if (Number(cur.price) < Number(values[acc].price)) return i;
    else return acc;
  }, 0);
};

const getLinkSoftDescriptor = (softDescriptor, mccConfig, testMode) => {
  if (softDescriptor) return softDescriptor;

  // Adiq exige exatamente 1 caractere '*' no soft descriptor - validação que só ocorre em dev/hml
  if (testMode) return "MRPAY*Check";

  if (mccConfig && mccConfig.establishment) {
    const establishment_name = mccConfig.establishment.slice(0, 19).trim();
    const normalize = establishment_name
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .replace(/[^a-zA-Z0-9 ]/g, "");
    return normalize;
  }
  return "Mr Pay";
};

const getRecurrenteSoftDescriptor = (checkoutPayment, checkoutSoftDescriptor) => {
  if (
    checkoutPayment &&
    checkoutPayment.recurrent_payment &&
    checkoutPayment.recurrent_payment.soft_descriptor
  ) {
    return checkoutPayment.recurrent_payment.soft_descriptor;
  }

  return checkoutSoftDescriptor;
};

const getCountryName = (countryAcronym) => {
  const countryName = Object.keys(countries).find((country) => {
    return countries[country] === countryAcronym;
  });
  return countryName || "";
};

const months = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
];

const bandeiras = {
  VISA,
  MASTER,
  ELO,
  HIPERCARD,
  AMEX,
};

const states = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
];

const payment_type = ["Cartão de crédito", "Pix"];

const success_state = ["CON", "PPC", "PEN"];

const failure_state = ["INV", "NEG", "BLQ"];

const cancel_state = ["PPN", "ERR", "EXP", "CAN"];

function Link(props) {
  const { id: _id } = useParams();
  const challengerRef = useRef(null);
  const attempt = props.location.state?.count || 1; // Tentativas
  const testMode = /(hml-)|(localhost)/.test(window.location.href);
  const formRef = useRef();
  const recaptchaRef = useRef();
  const inputRef = useRef(null);
  const [stage, setStage] = useState(0);
  const [cepError, setCepError] = useState(false);
  const [showCepInfo, setShowCepInfo] = useState(0);
  const [billingShowCepInfo, setBillingShowCepInfo] = useState(0);
  const [errorDelivery, setErrorDelivery] = useState(false);
  const [billingCepError, setBillingCepError] = useState(false);
  const [reveal, setReveal] = useState([]);
  const [payerAddress, setPayerAddress] = useState(false);
  const [disableInput, setDisableInput] = useState({});
  const [IsAlready, setIsAlready] = useState(true);
  const [circleLoad, setCircleLoad] = useState(false);
  const [isInvalidToken, setIsInvalidToken] = useState(false);
  const [authData, setAuthData] = useState({});

  const { setFullPageLoading } = useContext(FullPageLoaderContext);
  const { setFullPaymentLoading, setPaymentStatus } = useContext(PaymentPageLoaderContext);
  const { showInformationPopUp } = useContext(InformationPopUpContext);

  const [mddValues, setMddValues] = useState([]);
  const [cardNumber, setCardNumber] = useState("");
  const [checkout_payload, setCheckout_payload] = useState({});
  const [config_payload, setConfig_payload] = useState({});
  const [transaction_values, setTransactionValues] = useState({
    paymentForm: "credCard",
    authorizerId: "",
    cardNumber: "",
    expiryMonth: "",
    expiryYear: "",
    cardName: "",
    securityCode: "",
    parcels: "",
    interest_amount: "", // Montante total com juros
    amount: "", // Montante total sem juros
    standard_amount: "", // Montanho padrão do carrinho (qnt, preço e desconto)
    discount_pix: "", // Desconto do pix parametrizado nas configurações
  });
  const transactionMethods = getTransactionMethod(
    config_payload.transactions,
    transaction_values.interest_amount || transaction_values.amount,
  );
  const letterButtonColor = config_payload
    ? lumCalc(config_payload.exhibition?.background_color || "#ffffff") > 128
      ? "black"
      : "white"
    : "black";

  const [values, setValues] = useState({
    deliveryCep: "",
    deliveryState: "",
    deliveryAddress: "",
    deliveryDistrict: "",
    deliveryCity: "",
    deliveryComplement: "",
    deliveryAddressNumber: "",
    deliveryCountry: "Brasil",
    receiverName: "",
    receiverPhone: "",
    deliveryType: [],
    deliveryChoice: 0,
    parcelValues: [],
    allowTerms: false,
    sameBillingToDelivery: false,
    billingCep: "",
    billingState: "",
    billingAddress: "",
    billingDistrict: "",
    billingCity: "",
    billingComplement: "",
    billingAddressNumber: "",
    billingCountry: "Brasil",
    identificationName: "",
    document_number: "",
    phone: "",
    email: "",
    emailConfirm: "",
    noRobot: false,
  });
  useEffect(() => {
    // ---------------- UseEffect real da chamada da api checkout
    setStage(0);
    setFullPageLoading(true);
    generatePage(_id);
  }, []);

  // Saída da tela de Checkout
  useEffect(() => {
    return () => {
      updateValues("parcelValues", []);
    };
  }, []);

  const generatePage = async (checkoutId) => {
    // Chamada real da api checkout
    try {
      await serverProvider(testMode)
        .getPageInformation(checkoutId)
        .then((resp) => {
          setCheckout_payload(resp.data);
          setConfig_payload(resp.config);
          setReveal(resp.data.cart.items.map(() => false));
          setStage(1);
          setFullPageLoading(false);
        })
        .catch((e) => {
          if (e.response.data) {
            const code = e.response.data.code;
            if (code === "?") {
              throw new Error(e.response.data.message);
            } else {
              setStage(code);
              setFullPageLoading(false);
              showInformationPopUp({
                message: e.response ? e.response.data.message : e.message,
              });
            }
          } else {
            throw new Error("Erro não identificado");
          }
        });
    } catch (e) {
      console.log("[e.checkout]", e);
      setStage(2);
      setFullPageLoading(false);
      showInformationPopUp({
        message: e.response ? e.response.data.message : e.message,
      });
    }
  };

  // useEffect(() => {
  //   // ---------------------------- UseEffect para homologação
  //   setStage(0);
  //   setFullPageLoading(false);
  //   // getFingerPrint(checkoutec.merchant_order_id);
  //   generatePageTeste();
  // }, []);

  const generatePageTeste = async () => {
    //setFullPageLoading(true);

    try {
      // await sleep(500); // Fazer o código esperar pra renderizar
      // setCheckout_payload(checkoutec);
      // setConfig_payload(configec);
      // setReveal(checkoutec.cart.items.map(() => false));
      // setStage(1);
      // setFullPageLoading(false);
    } catch (e) {
      setStage(2);
      setFullPageLoading(false);
      showInformationPopUp({
        message: e.response ? e.response.data.message : e.message,
      });
    }
  };

  const buildPageShipping = async (shipping) => {
    // Seta no values.deliveryType os campos de services
    if (shipping.type === "fixed_amount") {
      const initial_value = initializeShipping(shipping.services);

      updateValues("deliveryType", shipping.services);
      updateValues("deliveryChoice", initial_value);

      const add_shipping_value = String(
        Number(transaction_values.standard_amount) + Number(shipping.services[initial_value].price),
      );
      updateTransactionValues("amount", add_shipping_value);
    }

    // Calcula a entrega ao identificar que é do tipo correios e já possui target_cep
    if (shipping.type === "correios") {
      if (shipping.target_zipcode) {
        setDisableInput((old) => ({
          ...old,
          deliveryCep: shipping.target_zipcode ? true : false,
        }));
        shippingInfoServices(shipping.target_zipcode).catch(() => {});
      }
    }

    // Executa a busca do CEP caso exista na API e o address não fornecido
    if (shipping.target_zipcode && !shipping.address) {
      setDisableInput((old) => ({
        ...old,
        deliveryCep: shipping.target_zipcode ? true : false,
      }));
      setValues((old) => ({ ...old, deliveryCep: shipping.target_zipcode }));
      setShowCepInfo(1);
    }

    if (shipping.address) {
      setDisableInput((old) => ({
        ...old,
        deliveryCep: shipping.target_zipcode ? true : false,
        deliveryAddress: shipping.address.street ? true : false,
        deliveryComplement: shipping.address.complement ? true : false,
        deliveryAddressNumber: shipping.address.number ? true : false,
        deliveryDistrict: shipping.address.district ? true : false,
        deliveryCity: shipping.address.city ? true : false,
        deliveryState: shipping.address.state ? true : false,
        deliveryCountry: shipping.address.country ? true : false,
      }));

      setValues((old) => ({
        ...old,
        deliveryCep: shipping.target_zipcode,
        deliveryAddress: shipping.address.street || "",
        deliveryComplement: shipping.address.complement || "",
        deliveryAddressNumber: shipping.address.number || "",
        deliveryDistrict: shipping.address.district || "",
        deliveryCity: shipping.address.city || "",
        deliveryState: shipping.address.state || "",
        deliveryCountry: getCountryName(shipping.address.country) || "",
      }));

      setShowCepInfo(1);
    }

    // Seta os campos de endereçado
    if (shipping.addressee) {
      setDisableInput((old) => ({
        ...old,
        receiverName: shipping.addressee.full_name ? true : false,
        receiverPhone: shipping.addressee.phone ? true : false,
      }));

      setValues((old) => ({
        ...old,
        receiverName: shipping.addressee.full_name || "",
        receiverPhone: formatPhoneNumber(shipping.addressee.phone),
      }));
    }
  };

  const buildPagePayer = (payer) => {
    const name = payer.name?.trim() || "";
    const surname = payer.surname?.trim() || "";
    const complete_name = name && surname ? `${name} ${surname}` : name ? `${name}` : "";

    const payer_information = {
      identificationName: complete_name,
      document_number: formatCpfCnpj(payer.identification_number),
      phone: formatPhoneNumber(payer.phone) || "",
      email: payer.email || "",
      emailConfirm: payer.email || "",
    };

    const payer_address = {
      billingCep: payer.address_zip_code,
      billingAddress: payer.address_street_name || "",
      billingComplement: payer.address_street_complement || "",
      billingAddressNumber: payer.address_street_number || "",
      billingDistrict: payer.address_neighborhood || "",
      billingCity: payer.city || "",
      billingState: payer.state || "",
      billingCountry: getCountryName(payer.address_country) || "",
    };

    // Verifica se algum campo de endereço está preenchido
    const exists_payer_address = Object.keys(payer_address).some((item) => payer_address[item]);
    if (exists_payer_address) {
      setPayerAddress(true);
      setBillingShowCepInfo(1);
    }

    setDisableInput((old) => ({
      ...old,
      identificationName: payer_information.identificationName ? true : false,
      document_number: payer_information.document_number ? true : false,
      phone: payer_information.phone ? true : false,
      email: payer_information.email ? true : false,
      emailConfirm: payer_information.email ? true : false,
      billingCep: payer_address.billingCep ? true : false,
      billingAddress: payer_address.billingAddress ? true : false,
      billingComplement: payer_address.billingComplement ? true : false,
      billingAddressNumber: payer_address.billingAddressNumber ? true : false,
      billingDistrict: payer_address.billingDistrict ? true : false,
      billingCity: payer_address.billingCity ? true : false,
      billingState: payer_address.billingState ? true : false,
      billingCountry: payer_address.billingCountry ? true : false,
    }));

    setValues((old) => ({ ...old, ...payer_information, ...payer_address }));
  };

  // Monta a página com payload's estáticos do checkout e da config
  useEffect(() => {
    // Executa 3x (Há 3 setState's)
    // Valor padrão do Total (amount)
    if (!transaction_values.amount) {
      if (checkout_payload.cart) {
        // manipula o valor do amount
        const standard_amount = String(
          Math.round(subtotalValue(checkout_payload) - discountValue(checkout_payload)),
        );
        updateTransactionValues("standard_amount", standard_amount);
        updateTransactionValues("amount", standard_amount);
      }
    } else {
      if (config_payload.payments?.discount_for_payment_with_Pix) {
        const amount = Number(transaction_values.standard_amount);
        const discount = config_payload.payments.discount_for_payment_with_Pix;

        const value_discounted = discountWithPix(amount, discount);
        updateTransactionValues("discount_pix", Number(value_discounted.toFixed(1)));
      }
    }

    // verifica se o estado da ChechBox de "Mesmo endereço da entrega"
    if (!values.sameBillingToDelivery) {
      if (checkout_payload.shipping && payerAddress) {
        // manipula o estado do endereço de cobrança
        if (["correios", "fixed_amount", "free"].includes(checkout_payload.shipping?.type)) {
          updateValues("sameBillingToDelivery", true);
        }
      }
    }

    // Seta valores padrão dos mdd's não-coletáveis no Checkout
    if (
      mddValues?.length === 0 &&
      Object.keys(config_payload).length !== 0 &&
      Object.keys(checkout_payload).length !== 0
    ) {
      setInitialMddValues(
        [21, config_payload.mdd?.mcc || ""], // Código do mcc
        [22, `${config_payload.mdd?.mcc || ""}-${config_payload.mdd?.establishment || ""}`], // MCC com nome (Cód + Nome do estabel. ex: 999-Construção LTDA)
        [23, config_payload.mdd?.establishment || ""], // Nome do estabelecimento
        [24, "Web"], // Canal da venda
        [25, "Digitado"], // Cartão foi colado ou digitado?
        [27, config_payload.mdd?.product_category || ""], // Categoria do produto
        [28, "False"], // Cliente efetuou login?
        [30, checkout_payload.document_number.length === 14 ? checkout_payload.document_number : ""], // CNPJ do estabelecimento
        [33, "Digitado"], // 	E-mail foi colado ou digitado?
        [36, String(attempt)], // 	Número de tentativas
        [39, config_payload.mdd?.segment || ""], // Segmento (vertical)
        [45, checkout_payload.document_number.length === 11 ? checkout_payload.document_number : ""], // CPF do Vendedor
        [46, "Transacional"], // Tipo de Chamada
        [47, config_payload.mdd?.manual_revision ? "sim" : "não"], // Cliente aderiu a revisão manual?
        [
          48,
          `${getDaysSeller(
            config_payload.created.split("T")[0],
            new Date().toISOString().split("T")[0],
          )}`,
        ], // Vendedor a XX dias
      );
    }

    // Função responsável por identificar dados advindos da API Checkout e montar a página
    if (Object.keys(config_payload).length !== 0 && Object.keys(checkout_payload).length !== 0) {
      if (checkout_payload.shipping) {
        buildPageShipping(checkout_payload.shipping);
      }
      if (checkout_payload.additional_data?.payer) {
        buildPagePayer(checkout_payload.additional_data.payer);
      }
    }
  }, [checkout_payload, config_payload]);

  useEffect(() => {
    enablePayment();
  }, [values, transaction_values]);

  useEffect(() => {
    const exists_checkout_data = Object.keys(checkout_payload).length !== 0;
    const exists_config_data = Object.keys(config_payload).length !== 0;

    if (exists_checkout_data && exists_config_data) {
      // Calcula as parcelas com o desconto aplicado
      if (transaction_values.paymentForm === "credCard") {
        // Não paga recorrência com parcelas, então seta apenas o pagamen. à vista
        if (checkout_payload.payment?.recurrent_payment) {
          updateValues("parcelValues", [
            {
              parcel_number: 1,
              installment_amount: transaction_values.amount,
              installment: transaction_values.amount,
            },
          ]);
          updateTransactionValues("parcels", "1");
        } else {
          if (checkout_payload.shipping) {
            if (
              checkout_payload.shipping.type === "free" ||
              checkout_payload.shipping.type === "without_shipping_pick_up"
            ) {
              // Não tem frete, logo não modifica o valor a ser parcelado
              const { document_number, mid, payment } = checkout_payload;
              getInstallmentValues(transaction_values.amount, document_number, mid, payment);
            } else {
              // Se não estiver selecionado, não calcula as parcelas
              if (values.deliveryType[values.deliveryChoice]?.price) {
                const { document_number, mid, payment } = checkout_payload;
                getInstallmentValues(transaction_values.amount, document_number, mid, payment);
              }
            }
          } else {
            // Não tem entrega, calcula as parcelas direto
            const { document_number, mid, payment } = checkout_payload;
            getInstallmentValues(transaction_values.amount, document_number, mid, payment);
          }
        }
      }
    }
  }, [transaction_values.amount]);

  useEffect(() => {
    // Executa o finger print sempre que entrar na quantidade necessária
    // para utilizar o antifraud
    if (transactionMethods.antifraud) {
      getFingerPrint(checkout_payload.merchant_order_id);
    }
  }, [transactionMethods.antifraud]);

  const checkCardChanged = (newCardNumber) => {
    // Checa se número de cartão foi mudado
    if (newCardNumber === "" && cardNumber.length === 16 && newCardNumber !== cardNumber) {
      setCardNumber(newCardNumber);
      return "True";
    } else {
      if (mddValues.mdd_26 === "True") return "True";
      else {
        if (newCardNumber.length === 16) setCardNumber(newCardNumber);
        return "False";
      }
    }
  };

  const enablePayment = () => {
    const payer_data = {
      delivery: {
        deliveryCep: values.deliveryCep,
        deliveryState: values.deliveryState,
        deliveryAddress: values.deliveryAddress,
        deliveryDistrict: values.deliveryDistrict,
        deliveryCity: values.deliveryCity,
        deliveryComplement: values.deliveryComplement,
        deliveryAddressNumber: values.deliveryAddressNumber,
        receiverName: values.receiverName,
        receiverPhone: values.receiverPhone,
      },
      info: {
        identificationName: values.identificationName,
        document_number: values.document_number,
        phone: values.phone,
        email: values.email,
        emailConfirm: values.emailConfirm,
      },
      address: {
        billingCep: values.billingCep,
        billingState: values.billingState,
        billingAddress: values.billingAddress,
        billingDistrict: values.billingDistrict,
        billingCity: values.billingCity,
        billingComplement: values.billingComplement,
        billingAddressNumber: values.billingAddressNumber,
      },
      more: {
        allowTerms: values.allowTerms,
      },
    };

    // Copia sem referência os dados para transação
    const payment_data = JSON.parse(JSON.stringify(transaction_values));

    // Caso o campo não exista, ele não contará como condição pra liberar o botão
    if (!config_payload.payments?.discount_for_payment_with_Pix) {
      delete payment_data.discount_pix;
    }

    // Se estiver vazio, é um montante sem juros que pode ser ignorado
    if (!payment_data.interest_amount) {
      delete payment_data.interest_amount;
    }

    if (!checkout_payload.shipping || checkout_payload.shipping?.type === "without_shipping_pick_up") {
      delete payer_data.delivery;
    }

    // Retorna true para um campo caso todos estejam preenchidos
    const enable_payer = Object.keys(payer_data).map((item) => {
      return Object.keys(payer_data[item]).every((elem) => payer_data[item][elem]);
    });

    // Só retornar true caso todos os campos de payer_data.info e payer_data.address estiverem preenchidos
    const enable_info = enable_payer.includes(false) ? false : true;

    // Ficar enable caso os campos de cartão de crédito estiverem preenchidos
    const enable =
      payment_data.paymentForm === "pix"
        ? false
        : !Object.keys(payment_data).every((item) => payment_data[item]);

    !enable && enable_info ? setIsAlready(false) : setIsAlready(true);
  };

  // Habilita as parcelas para ser escolhida
  const enableInstallments = () => {
    // Se tiver agendamento, desabilita as parcelas
    if (checkout_payload.payment?.recurrent_payment) {
      return false;
    }

    return !checkout_payload.shipping
      ? true
      : checkout_payload.shipping.type !== "fixed_amount" &&
          checkout_payload.shipping.type !== "correios"
        ? true
        : values.deliveryType[values.deliveryChoice]?.price
          ? true
          : false;
  };

  const doSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = { ...transaction_values }; // copia os dados sem referência
      const info = JSON.parse(JSON.stringify(values));

      const checkoutPayload = JSON.parse(JSON.stringify(checkout_payload));
      const mdd = JSON.parse(JSON.stringify(mddValues));

      const shippingType = Object.keys(checkoutPayload).includes("shipping")
        ? checkoutPayload.shipping.type
        : "";
      const payload_validation = { ...data, ...info, shippingType };
      await getBodyRequest("submitSchema", payload_validation).catch((e) => {
        throw e;
      });

      setCircleLoad(true);

      if (isInvalidToken) {
        const title = "Captcha indisponível";
        const message = "Aguarde alguns instantes ou recarregue a página antes de tentar novamente.";
        return endPaymentFlow(title, message);
      }

      const token = await recaptchaRef.current.executeAsync();
      const captcha_reponse = await submitCaptcha(token);
      if (captcha_reponse.failure) {
        const title = "Ops! O captcha não foi concluído corretamente";
        const message = "Por favor, tente novamente.";
        return endPaymentFlow(title, message);
      }

      const checkoutId = {
        mrpay_api_id: checkoutPayload.mrpay_api_id,
        mrpay_api_key: checkoutPayload.mrpay_api_key,
      };

      if (transaction_values.paymentForm === "pix") {
        props.history.push("/pix", { attempt, checkout_payload, info, config_payload, data, testMode });
      } else {
        setFullPaymentLoading(true);
        setPaymentStatus("Criando transação");

        info.deliveryForm = checkout_payload.shipping?.type;

        data.discount = Math.trunc(discountValue(checkout_payload));
        const exists_postpone = checkout_payload.additional_data?.postpone_confirmation ? true : false;
        data.confirmation = exists_postpone
          ? checkout_payload.additional_data.postpone_confirmation
          : config_payload.antifraud?.antifraud_and_automatic_capture === 0
            ? "true"
            : "false";
        data.antifraud = transactionMethods.antifraud;
        data.authentication = transactionMethods.auth;
        data.link_soft_descriptor = getLinkSoftDescriptor(
          checkoutPayload.soft_descriptor,
          config_payload.mdd,
          testMode,
        );
        data.recurrent_soft_descriptor = getRecurrenteSoftDescriptor(
          checkoutPayload.payment,
          data.link_soft_descriptor,
        );

        // Bloco de transação recorrente
        const isSchedule = checkoutPayload.payment?.recurrent_payment;
        if (isSchedule) {
          const args = { data, info, checkoutPayload, mdd };
          const { schedule } = await serverProvider(testMode).createTransaction(...args);

          const sid = schedule.sid;
          return await schedulePayment({ sid, data });
        }

        // Transação sem autenticação (ou testMode, que ignora o 3DS em DEV/HML):
        // também usa a v1 (create + pay), sem 3DS e sem antifraude
        const withoutAuth = !transactionMethods.auth || testMode;
        if (withoutAuth) {
          data.authentication = false;
          data.antifraud = false;
        }

        // Passo 1: cria a transação (NOV); com 3DS ligado quando exigido. O nit é usado em todo o fluxo
        const created = await serverProvider(testMode).createTransaction(
          data,
          info,
          checkoutPayload,
          mdd,
        );
        const nit = created.payment?.nit;
        if (!nit) throw new Error("Transação criada sem nit");

        if (withoutAuth) {
          return await transactionPayment({ nit, data });
        }

        // Passo 2: autenticação 3DS
        const args = { nit, data, checkoutId, info, checkoutPayload };
        await startPayerAuthFlow(args);
      }
    } catch (error) {
      console.log("[submit error]", error);
      const message = error.response ? error.response.data.message : "";
      endPaymentFlow("Erro ao criar transação", message);
    }
  };

  const startPayerAuthFlow = async ({ nit, data, checkoutId, info, checkoutPayload: checkout }) => {
    // faz setup de autenticação 3DS
    setPaymentStatus("Autenticando transação");
    try {
      const { consumer_authentication_information: cai = {}, error_information: ei } =
        await serverProvider(testMode).getSetupData({ nit, data, checkoutId });
      if (ei) {
        console.log("[ei]", ei);
      }
      const { accessToken, referenceId, deviceDataCollectionUrl } = cai;

      // seta action do form de autenticação 3DS
      formRef.current.action = deviceDataCollectionUrl;

      // seta JWT no input do form de autenticação 3DS
      inputRef.current.value = accessToken;

      // submete form de autenticação 3DS
      // ddcForm?.submit();
      formRef.current?.submit();

      // A origem esperada vem da própria URL de coleta devolvida no setup,
      // pois o domínio do Cardinal muda e uma env fixa deixa de bater
      const ddcOrigin = new URL(deviceDataCollectionUrl).origin;

      const messageCybs = async (event) => {
        try {
          if (event.origin === ddcOrigin) {
            const eventData = JSON.parse(event.data);
            if (eventData !== undefined && eventData.Status) {
              // Remove o endereço da função da lista de Eventos
              window.removeEventListener("message", messageCybs);
              // realiza chamada de enrollment
              await doEnrollment({
                nit,
                data,
                checkoutId,
                info,
                checkout,
                reference_id: referenceId,
              });
              setIsAlready(true);
            }
          }
        } catch (error) {
          console.log("[error]", error);
          endPaymentFlow("Falha na chamada do enrollment", error.message);
        }
      };

      window.addEventListener("message", messageCybs);
    } catch (e) {
      console.log("[e sethPayer]", e);
      endPaymentFlow("Falha na autenticação", e.response?.data?.message || e.message);
    }
  };

  const doEnrollment = async ({ nit, data, checkoutId, info, checkout, reference_id }) => {
    // busca inscrição do cartão no programa 3DS
    const enrollmentData = await serverProvider(testMode).getEnrollmentData({
      nit,
      data,
      checkoutId,
      info,
      checkout,
      reference_id,
    });

    // trata a resposta
    await treatEnrollmentResponse({ enrollmentData, info, nit, data, checkoutId });
  };

  const treatEnrollmentResponse = async ({ enrollmentData, info, nit, data, checkoutId }) => {
    const { consumer_authentication_information: cai } = enrollmentData;

    // erro 201 do diretório indica que a coleta de device (DDC) não foi concluída: sem autenticação real
    if (cai.directoryServerErrorCode === "201") {
      return endPaymentFlow("Falha", "Não foi possível autenticar o pagamento. Tente novamente.");
    }

    switch (cai.veresEnrolled) {
      case "Y":
        switch (cai.paresStatus) {
          case "Y":
            // sucesso - autenticação silenciosa (frictionless): segue para o pagamento
            return await transactionPayment({ nit, data });
          case "N":
            endPaymentFlow("Falha", "Seu pagamento não foi aprovado pelo emissor do seu cartão");
            break;
          case "A":
            endPaymentFlow("Falha", "Seu cartão não suporta autenticação de pagamento");
            break;
          case "U":
            endPaymentFlow("Falha", "Pagamento não autorizado");
            break;
          case "R":
            endPaymentFlow("Falha", "Seu pagamento não foi aprovado pelo emissor de seu cartão");
            break;
          default:
            // Desafio necessário

            // // decodifica pareq (onde tem informação de tamanho de iframe de challenge)
            const buff = Buffer.from(cai.pareq, "base64");
            const decoded = buff.toString("utf-8");
            const pareqObj = JSON.parse(decoded);

            // // busca dimensões de iframe
            const { challengeWindowSize } = pareqObj;
            const dimensions = getiFrameDimensions(challengeWindowSize);

            // // inicia iframe e form de step-up
            await setPayerAuthChallengeElements({
              accessToken: cai.accessToken,
              deviceDataCollectionUrl: cai.stepUpUrl,
              dimensions,
            });

            challengerRef.current?.submit();

            startRoutine({
              nit: nit,
              info,
              transactionId: cai.authenticationTransactionId,
              data: data,
              checkout: checkoutId,
            });
            break;
        }
        break;
      case "U":
        endPaymentFlow("Falha", "O emissor do seu cartão não permitiu a autenticação do pagamento");
        break;
      case "B":
        endPaymentFlow("Falha", "Pagamento não autorizado");
        break;
      case "R":
        endPaymentFlow("Falha", "Pagamento não autorizado");
        break;
      default:
        endPaymentFlow("Falha", "Pagamento não autorizado");
        break;
    }
  };

  const setPayerAuthChallengeElements = async ({ accessToken, deviceDataCollectionUrl, dimensions }) => {
    setAuthData({
      accessToken,
      deviceDataCollectionUrl,
      dimensions,
    });
  };

  const startRoutine = async ({ nit, info, transactionId, data, checkout }) => {
    setFullPaymentLoading(false);

    try {
      const challenge_finished = await serverProvider(testMode).checkChallengeCompletation(
        nit,
        checkout,
      );
      if (challenge_finished) {
        setFullPaymentLoading(true);
        setPaymentStatus("Verificando validação");
        await getValidateData({ nit, info, transactionId, data, checkout });
      } else {
        setTimeout(() => {
          startRoutine({ nit, info, transactionId, data, checkout });
        }, 5000);
      }
    } catch (e) {
      console.log("[e - routine]", e);

      setTimeout(() => {
        startRoutine({ nit, transactionId, data, checkout });
      }, 5000);
    }
  };

  const getValidateData = async ({ nit, info, transactionId, data, checkout }) => {
    try {
      // // remove popup de challenge da tela
      setAuthData({});

      // valida resultados
      const validateResponse = await serverProvider(testMode).getValidateData(
        nit,
        transactionId,
        data,
        checkout,
      );

      // EFETUAR PAGAMENTO
      const cai = validateResponse.consumer_authentication_information;
      const { eci, eciRaw } = cai;

      // verifica se é retornou um eci válido (02 ou 05)
      const isValidEci = ["02", "05"].includes(eci || eciRaw);
      if (isValidEci) {
        // se o eci for válido, o pagador está autenticado
        return await transactionPayment({ nit, data });
      } else {
        // se o eci não for válido, o pagador não está autenticado
        endPaymentFlow("", "O pagamento não foi autenticado");
      }
    } catch (e) {
      console.log("[payment validation error]", e.message);
      setAuthData({});

      setFullPaymentLoading(false);
      showInformationPopUp({ message: "Falha ao realizar pagamento" });
    }
  };

  const endPaymentFlow = (title = "", message = "") => {
    setCircleLoad(false);
    setFullPaymentLoading(false);
    showInformationPopUp({
      title: title || "Não foi possível realizar o pagamento",
      message: [message],
    });
    //clearFields(); // Limpa os campos
    // setConfirmation(false); // tira bug de chamada durante desenvolvimento
  };

  const redirectToEndPage = (transactionResponse, type) => {
    setFullPaymentLoading(false); // Encerra o Loading

    // type indica o tipo de transação (pagamento, preautorização)

    const payment_detail =
      type === "schedule"
        ? {
            payment_detail: {
              amount: transaction_values.amount,
              installment: "1",
              authorizer_id: transaction_values.authorizerId,
              payment_type: transaction_values.paymentForm,
              payment_date: "",
            },
          }
        : {
            response_message: transactionResponse[type].authorizer_message,
            payment_detail: {
              establishment: checkout_payload.document_number,
              authorization_number: transactionResponse[type].authorization_number,
              emrpay_usn: transactionResponse[type].emrpay_usn,
              amount:
                transactionResponse[type].payment_amount ||
                transaction_values.interest_amount ||
                transaction_values.amount,
              installment: transaction_values.parcels,
              authorizer_id: transactionResponse[type].authorizer_id,
              payment_type: transactionResponse[type].payment_type || transaction_values.paymentForm,
              payment_date: transactionResponse[type].payment_date,
            },
          };

    const end_payload = {
      id: _id,
      count: attempt,
      message: transactionResponse.message,
      ...payment_detail,
      transaction_detail: {
        order: checkout_payload.merchant_order_id,
        interest_value: transaction_values.amount,
        product_detail: checkout_payload.cart,
        shipping_detail: checkout_payload.shipping
          ? {
              type: checkout_payload.shipping?.type || "",
              delivery_name: values.deliveryType[values.deliveryChoice]?.name || "",
              delivery_price: values.deliveryType[values.deliveryChoice]?.price || "",
              delivery_time: values.deliveryType[values.deliveryChoice]?.deadline || "",
            }
          : "",
      },
      payer_data: {
        name: values.identificationName,
        phone: values.phone,
        email: values.email,
      },
      style_page: {
        logo: config_payload.exhibition?.logo || "",
        background_color: config_payload.exhibition?.background_color || "",
      },
    };

    if (type === "schedule") {
      if (transactionResponse.payment.status === "ATV") {
        props.history.push("/checkout/success", end_payload);
      } else {
        props.history.push("/checkout/failure", end_payload);
      }
    } else {
      if (success_state.includes(transactionResponse[type].status)) {
        props.history.push("/checkout/success", end_payload);
      }

      if (failure_state.includes(transactionResponse[type].status)) {
        props.history.push("/checkout/failure", end_payload);
      }

      if (cancel_state.includes(transactionResponse[type].status)) {
        props.history.push("/checkout/cancel", end_payload);
      }
    }
  };

  const transactionPayment = async ({ nit, data }) => {
    setPaymentStatus("Efetivando transação");
    try {
      const checkoutPayload = JSON.parse(JSON.stringify(checkout_payload));
      const transaction_type = checkoutPayload.transaction_type || "payment";

      if (transaction_type === "preauthorization") {
        const ppResponse = await serverProvider(testMode).preauthorizationPayment(
          nit,
          data,
          checkoutPayload,
        );

        redirectToEndPage(ppResponse, "pre_authorization");
      } else {
        const tpResponse = await serverProvider(testMode).transactionPayment(nit, data, checkoutPayload);

        redirectToEndPage(tpResponse, "payment");
      }
    } catch (e) {
      console.log("[transactionPayment error]", e);

      // Erro sem resposta (rede, timeout, 5xx/504): o pagamento pode ter sido processado.
      // Consulta a transação antes de qualquer nova tentativa.
      if (e.unknownStatus) {
        return await checkUnknownPaymentStatus(nit);
      }

      endPaymentFlow("", e.message);
      return e;
    }
  };

  const checkUnknownPaymentStatus = async (nit) => {
    setPaymentStatus("Verificando pagamento");
    try {
      const response = await serverProvider(testMode).getTransaction(nit, checkout_payload);
      const status = response.payment?.status;
      if (status && !["NOV"].includes(status)) {
        return redirectToEndPage(response, "payment");
      }
    } catch (err) {
      console.log("[getTransaction error]", err);
    }

    return endPaymentFlow(
      "Não foi possível confirmar o pagamento",
      "Não tente novamente agora. Verifique o status da compra com o estabelecimento antes de repetir o pagamento.",
    );
  };

  const schedulePayment = async ({ sid, data }) => {
    setPaymentStatus("Ativando agendamento");
    try {
      const checkoutPayload = JSON.parse(JSON.stringify(checkout_payload));

      const scResponse = await serverProvider(testMode).schedulePayment(sid, data, checkoutPayload);

      redirectToEndPage(scResponse, "schedule");
    } catch (e) {
      console.log("[transactionSchedule error]", e);

      endPaymentFlow("", e.message);
      return e;
    }
  };

  const updateValues = (fieldname, value) => {
    setValues((old) => ({ ...old, [fieldname]: value }));
  };

  const updateTransactionValues = (fieldname, value) => {
    setTransactionValues((old) => ({ ...old, [fieldname]: value }));
  };

  const setInitialMddValues = (...value) => {
    value.forEach((elem) => {
      setMddValues((old) => ({ ...old, [`mdd_${elem[0]}`]: elem[1] }));
    });
  };

  const setDeliveryAddress = (address) => {
    // State responsável por tornar os campos disable
    setDisableInput((old) => ({
      ...old,
      deliveryState: address.estado ? true : false,
      deliveryAddress: address.endereco ? true : false,
      deliveryDistrict: address.bairro ? true : false,
      deliveryCity: address.cidade ? true : false,
    }));

    setValues((old) => ({
      ...old,
      deliveryState: address.estado,
      deliveryCep: address.cep,
      deliveryAddress: address.endereco,
      deliveryDistrict: address.bairro,
      deliveryCity: address.cidade,
    }));
  };

  const setBillingAddress = (address) => {
    // State responsável por tornar os campos disable
    setDisableInput((old) => ({
      ...old,
      billingState: address.estado ? true : false,
      billingAddress: address.endereco ? true : false,
      billingDistrict: address.bairro ? true : false,
      billingCity: address.cidade ? true : false,
    }));

    setValues((old) => ({
      ...old,
      billingState: address.estado,
      billingCep: address.cep,
      billingAddress: address.endereco,
      billingDistrict: address.bairro,
      billingCity: address.cidade,
    }));
  };

  const sameBillingToDelivery = (equal) => {
    setValues((old) => ({
      ...old,
      billingState: equal ? old.deliveryState : "",
      billingCep: equal ? old.deliveryCep : "",
      billingAddress: equal ? old.deliveryAddress : "",
      billingDistrict: equal ? old.deliveryDistrict : "",
      billingCity: equal ? old.deliveryCity : "",
      billingComplement: equal ? old.deliveryComplement : "",
      billingAddressNumber: equal ? old.deliveryAddressNumber : "",
      billingCountry: equal ? old.deliveryCountry : "",
    }));
  };

  const clearDeliveryAddressValues = () => {
    const deliveryValues = {
      deliveryState: "",
      deliveryCep: "",
      deliveryAddress: "",
      deliveryDistrict: "",
      deliveryCity: "",
      deliveryComplement: "",
      deliveryAddressNumber: "",
    };
    setValues((old) => ({
      ...old,
      ...deliveryValues,
    }));

    setDisableInput((old) => ({
      ...old,
      ...deliveryValues,
    }));
  };

  const clearBillingAddressValues = () => {
    const billingValues = {
      billingState: "",
      billingCep: "",
      billingAddress: "",
      billingDistrict: "",
      billingCity: "",
      billingComplement: "",
      billingAddressNumber: "",
    };
    setValues((old) => ({
      ...old,
      ...billingValues,
    }));

    setDisableInput((old) => ({
      ...old,
      ...billingValues,
    }));
  };

  const getFingerPrint = (order_id) => {
    const merchant_id = process.env.REACT_APP_CYBS_MERCHANT_ID;
    let newFingerprintScript = document.createElement("script");
    const idFingerprint = "fingerprint-script";
    newFingerprintScript.setAttribute("type", "text/javascript");
    newFingerprintScript.setAttribute("id", idFingerprint);
    const srcFingerprint = `https://h.online-metrix.net/fp/tags.js?org_id=${process.env.REACT_APP_CYBS_ORG_ID}&session_id=${merchant_id}${order_id}`;
    newFingerprintScript.setAttribute("src", srcFingerprint);

    document.body.appendChild(newFingerprintScript);
    return () => {
      document.body.removeChild(newFingerprintScript);
    };
  };

  // Busca informações de preço e prazo no backend
  const shippingInfoServices = (target_cep) => {
    return new Promise(async (resolve, reject) => {
      try {
        const shipping_response = await serverProvider(testMode).getDeliveryData(
          target_cep,
          checkout_payload,
        );

        if (
          shipping_response &&
          shipping_response.constructor === Array &&
          shipping_response.length === 0
        ) {
          setErrorDelivery(true);
        } else {
          const initial_value = initializeShipping(shipping_response);
          const amount = Number(transaction_values.standard_amount);
          const pix_discount =
            transaction_values.paymentForm !== "pix" ? 0 : Number(transaction_values.discount_pix);
          const add_shipping_value = String(
            amount - pix_discount + Number(shipping_response[initial_value].price),
          );

          updateValues("deliveryType", shipping_response);
          updateValues("deliveryChoice", initial_value);
          updateTransactionValues("amount", add_shipping_value);
        }
        return resolve(shipping_response);
      } catch (e) {
        endPaymentFlow("Falha no tipo de entrega", e.message);
        setErrorDelivery(true);
        return reject(e);
      }
    });
  };

  // Busca informações do CEP no backend
  const fetchingCepInfo = async (cep) => {
    setShowCepInfo(2);
    return await searchCep(cep, testMode)
      .then((value) => {
        setDeliveryAddress(value);
        if (values.sameBillingToDelivery) sameBillingToDelivery(true);
        setShowCepInfo(1);
      })
      .catch((error) => {
        console.log("[error]", error);
        showInformationPopUp({
          message: error.response.msgs[0],
        });
        setCepError(true);
        setShowCepInfo(0);
      });
  };

  // Busca as parcelas no backend
  const getInstallmentValues = async (amount, doc, mid, payment) => {
    const installments = config_payload.payments.installment_type;
    const minimun_value = config_payload.payments.minimum_installment_value || 0;
    const checkout_payment = checkoutInstallment(payment);
    const server_response = await serverProvider(testMode).getInstallmentValues(
      amount,
      doc,
      mid,
      installments,
      minimun_value,
      checkout_payment,
    );
    if (server_response.code === 0) {
      // Insere apenas o array contendo as parcelas
      updateValues("parcelValues", server_response.installment);
    } else {
      endPaymentFlow("Falha no cálculo das parcelas", server_response.message);
      updateValues("parcelValues", "");
    }
  };

  const showDeliveryValues = () => {
    const delivery_values = values.deliveryType;
    const delivery_option = values.deliveryChoice;

    // Verifica se há serviços do correios habilitado nas configurações
    if (checkout_payload.shipping?.type === "correios") {
      if (config_payload.shipping_services) {
        const shipping_services = config_payload.shipping_services?.shipping_services;
        const not_exists = !Object.keys(shipping_services || {}).some((item) => shipping_services[item]);

        if (not_exists) {
          return <span>Nenhum serviço dos correios habilitado</span>;
        }
      } else {
        return <span>Serviço de entrega não configurado</span>;
      }
    }

    return delivery_values.length !== 0 ? (
      delivery_values.map((item, i) => {
        const key = getKey();
        return (
          <div key={key}>
            <label>
              <input
                type="radio"
                id={item.name}
                name="deliveryChoice"
                value={i}
                defaultChecked={i === delivery_option}
                onClick={(e) => {
                  const { name: _name, value: _value } = e.target;
                  // verifica se tem desconto para pagamentos com pix
                  const pix_discount =
                    transaction_values.paymentForm !== "pix"
                      ? 0
                      : Number(transaction_values.discount_pix);
                  const add_shipping_value = String(
                    Number(transaction_values.standard_amount) -
                      pix_discount +
                      Number(delivery_values[Number(_value)].price),
                  );

                  updateValues(_name, Number(_value));
                  updateTransactionValues("amount", add_shipping_value);
                  // Põe o Loader na seleção das parcelas (Se o preço for diferente pra calcular)
                  if (
                    values.deliveryType[Number(_value)].price !==
                    values.deliveryType[delivery_option].price
                  ) {
                    updateValues("parcelValues", []);
                  }
                  // Limpa a parcela escolhida, se já selecionada
                  if (transaction_values.parcels) {
                    updateTransactionValues("parcels", "");
                    updateTransactionValues("interest_amount", "");
                  }
                }}
              />
              <label htmlFor={item.name}>
                {item.name} ({item.deadline} dia
                {item.deadline > 1 ? "s" : ""} út
                {item.deadline > 1 ? "eis" : "il"})
              </label>
              <span>{toMoneyFormat(item.price)}</span>
            </label>
          </div>
        );
      })
    ) : (
      <LoaderStyle>
        <Loader />
      </LoaderStyle>
    );
  };

  const submitCaptcha = async (e) => {
    return await serverProvider(testMode)
      .verifyCaptchaToken(e)
      .then((resp) => {
        if (!resp.success) return { failure: true, message: resp["error-codes"][0] };

        return { failure: false };
      })
      .catch((e) => ({ failure: true, message: e.message }));
  };

  return (
    <div>
      {stage === 1 && (
        <Divbackground bgColor={config_payload.exhibition?.background_color || "#e5e5e5"}>
          {/* <> */}
          <CheckoutLPBrasil>
            <CheckoutLPFlag src={brasil} alt="MrPay" />
            <p>Transação processada no Brasil</p>
          </CheckoutLPBrasil>

          {testMode ? (
            <CheckoutTestMode>
              <div className="alert">
                <img src={alert} alt="" />
              </div>
              <p>MODO DE TESTE ATIVO</p>
            </CheckoutTestMode>
          ) : (
            <></>
          )}

          <CheckoutLPContainer>
            <CheckoutForm onSubmit={doSubmit}>
              {/* Área a ser minimizada */}
              <InfoContents>
                <HeaderInfoContents>
                  <LogoImg
                    src={(config_payload.exhibition && config_payload.exhibition.logo) || logoImg}
                    alt="MrPay"
                  />
                  <SeloSecurity
                    bgColor={
                      (config_payload.exhibition && config_payload.exhibition.background_color) ||
                      "#F1B434"
                    }
                  />
                </HeaderInfoContents>

                {checkout_payload.shipping && (
                  <>
                    {checkout_payload.shipping.type === "without_shipping_pick_up" ? (
                      <>
                        <DeliveryType className="row">
                          <h2>Tipo de Entrega</h2>

                          <div className="deliveryTypePrices">
                            <span>Retirado na loja</span>
                          </div>
                        </DeliveryType>

                        <LineDivider />
                      </>
                    ) : (
                      <>
                        <DeliveryAddress>
                          <h2>Endereço de Entrega</h2>

                          <Address className="row">
                            <CountryCepContainer>
                              <CheckoutInformation className="addressCountry">
                                <div className="fieldName">
                                  <span>País</span>
                                </div>

                                <BoxSelectCheckoutLP>
                                  <SelectCheckoutLP
                                    name="deliveryCountry"
                                    disabled={disableInput.deliveryCountry}
                                    value={values.deliveryCountry}
                                    onChange={(e) => {
                                      const { name: _name, value: _value } = e.target;
                                      updateValues(_name, _value);

                                      if (_value !== "Brasil") {
                                        setShowCepInfo(1);
                                      } else {
                                        setShowCepInfo(0);
                                      }

                                      if (values.sameBillingToDelivery) {
                                        clearBillingAddressValues();
                                        updateValues("billingCountry", _value);
                                      }

                                      clearDeliveryAddressValues(); // Limpa os campos
                                    }}
                                  >
                                    <option>Selecione o país</option>
                                    {Object.keys(countries).map((country) => (
                                      <option key={country}>{country}</option>
                                    ))}
                                  </SelectCheckoutLP>
                                </BoxSelectCheckoutLP>
                              </CheckoutInformation>

                              <CheckoutInformation className="deliveryCep">
                                <div className="fieldName" style={{ width: "100%" }}>
                                  <span>CEP</span>
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    width: "100%",
                                    alignItems: "center",
                                    gap: "6px",
                                  }}
                                >
                                  <InputCheckoutLP
                                    style={
                                      cepError
                                        ? {
                                            borderColor: "#FF0000",
                                            color: "#FF0000",
                                          }
                                        : {}
                                    }
                                    id="cep"
                                    placeholder=""
                                    name="deliveryCep"
                                    className="centralize"
                                    disabled={disableInput.deliveryCep}
                                    maxLength={9}
                                    type="text"
                                    value={values.deliveryCep}
                                    onChange={async (e) => {
                                      setCepError(false);
                                      const { name: _name, value: _value } = e.target;
                                      const masked = _value.replace(/\D/g, "");

                                      if (values.deliveryCountry === "Brasil" && masked.length > 8)
                                        return;

                                      updateValues(_name, masked);

                                      if (values.deliveryCountry !== "Brasil") {
                                        if (values.sameBillingToDelivery) {
                                          updateValues("billingCep", _value);
                                        }
                                        return;
                                      }

                                      if (_value.replace(/(\D)/g, "").length === 8) {
                                        // setShowCepInfo(2);
                                        const { value: _value } = e.target;
                                        const _cep = _value.replace("-", "");
                                        if (_cep.length === 8) {
                                          // calcula o preço das entregas pro correios
                                          const {
                                            shipping_services: { shipping_services = {} },
                                          } = config_payload;
                                          const { shipping } = checkout_payload;

                                          const keys = Object.keys(shipping_services);
                                          const configShippiginServicesExists = keys.some(
                                            (item) => shipping_services[item],
                                          );
                                          const condition =
                                            shipping?.type === "correios" &&
                                            shipping_services &&
                                            configShippiginServicesExists;

                                          if (condition) {
                                            // Mostra o loader ao mudar de CEP
                                            if (Object.keys(values.deliveryType).length !== 0) {
                                              updateValues("deliveryType", []);
                                            }
                                            shippingInfoServices(_cep).catch(() => {});
                                          }

                                          // busca o CEP
                                          fetchingCepInfo(_cep);
                                        }
                                      }
                                    }}
                                  />
                                  {!disableInput.deliveryCep && (
                                    <div
                                      style={{
                                        width: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                    >
                                      <img className="questionImg" src={infoQuestion} alt="" />
                                      <a
                                        target="_blank"
                                        href="https://buscacepinter.correios.com.br/app/endereco/index.php"
                                        rel="noreferrer"
                                      >
                                        Não sei o CEP
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </CheckoutInformation>
                            </CountryCepContainer>
                            {showCepInfo === 1 && (
                              <>
                                <CheckoutInformation className="addressName">
                                  <div className="fieldName">
                                    <span>Endereço</span>
                                  </div>

                                  <InputCheckoutLP
                                    name="deliveryAddress"
                                    type="text"
                                    disabled={disableInput.deliveryAddress}
                                    value={values.deliveryAddress}
                                    onChange={(e) => {
                                      const { name: _name, value: _value } = e.target;
                                      updateValues(_name, _value);
                                      if (values.sameBillingToDelivery)
                                        updateValues("billingAddress", _value);
                                    }}
                                  />
                                </CheckoutInformation>

                                <CheckoutInformation className="addressNumber">
                                  <div className="fieldName">
                                    <span>Número</span>
                                  </div>

                                  <InputCheckoutLP
                                    name="deliveryAddressNumber"
                                    type="text"
                                    className="centralize"
                                    disabled={disableInput.deliveryAddressNumber}
                                    value={values.deliveryAddressNumber}
                                    onChange={(e) => {
                                      const { name: _name, value: _value } = e.target;
                                      updateValues(_name, _value);
                                      if (values.sameBillingToDelivery)
                                        updateValues("billingAddressNumber", _value);
                                    }}
                                  />
                                </CheckoutInformation>

                                <CheckoutInformation className="addressComplement">
                                  <div className="fieldName">
                                    <span>Complemento</span>
                                  </div>

                                  <InputCheckoutLP
                                    name="deliveryComplement"
                                    className="inputComplement"
                                    type="text"
                                    disabled={disableInput.deliveryComplement}
                                    value={values.deliveryComplement}
                                    onChange={(e) => {
                                      const { name: _name, value: _value } = e.target;
                                      updateValues(_name, _value);
                                      if (values.sameBillingToDelivery)
                                        updateValues("billingComplement", _value);
                                    }}
                                  />
                                </CheckoutInformation>

                                <CheckoutInformation className="addressDistrict">
                                  <div className="fieldName">
                                    <span>Bairro</span>
                                  </div>

                                  <InputCheckoutLP
                                    id="district"
                                    name="deliveryDistrict"
                                    type="text"
                                    disabled={disableInput.deliveryDistrict}
                                    value={values.deliveryDistrict}
                                    onChange={(e) => {
                                      const { name: _name, value: _value } = e.target;
                                      updateValues(_name, _value);
                                      if (values.sameBillingToDelivery)
                                        updateValues("billingDistrict", _value);
                                    }}
                                  />
                                </CheckoutInformation>

                                <CheckoutInformation className="addressCity">
                                  <div className="fieldName">
                                    <span>Cidade</span>
                                  </div>

                                  <InputCheckoutLP
                                    id="city"
                                    name="deliveryCity"
                                    type="text"
                                    disabled={disableInput.deliveryCity}
                                    value={values.deliveryCity}
                                    onChange={(e) => {
                                      const { name: _name, value: _value } = e.target;
                                      updateValues(_name, _value);
                                      if (values.sameBillingToDelivery)
                                        updateValues("billingCity", _value);
                                    }}
                                  />
                                </CheckoutInformation>

                                <CheckoutInformation className="addressState">
                                  <div className="fieldName">
                                    <span>Estado</span>
                                  </div>

                                  {values.deliveryCountry === "Brasil" ? (
                                    <BoxSelectCheckoutLP>
                                      <SelectCheckoutLP
                                        name="deliveryState"
                                        disabled={disableInput.deliveryState}
                                        value={values.deliveryState}
                                        onChange={(e) => {
                                          const { name: _name, value: _value } = e.target;
                                          updateValues(_name, _value);
                                          if (values.sameBillingToDelivery)
                                            updateValues("billingState", _value);
                                        }}
                                      >
                                        <option>UF</option>
                                        {states.map((state) => (
                                          <option key={state}>{state}</option>
                                        ))}
                                      </SelectCheckoutLP>
                                    </BoxSelectCheckoutLP>
                                  ) : (
                                    <InputCheckoutLP
                                      id="delivery-state"
                                      name="deliveryState"
                                      type="text"
                                      className="internationalState"
                                      placeholder=""
                                      maxLength={2}
                                      value={values.deliveryState}
                                      onChange={(e) => {
                                        const { name: _name, value: _value } = e.target;
                                        const acronym = _value.replace(/\d/g, "").toUpperCase();
                                        updateValues(_name, acronym);

                                        if (values.sameBillingToDelivery)
                                          updateValues("billingState", _value);
                                      }}
                                    />
                                  )}
                                </CheckoutInformation>

                                <ResponsibleReceiving>
                                  <h2>Responsável pelo Recebimento</h2>

                                  <ReceiverInformation>
                                    <CheckoutInformation className="receiverName">
                                      <div className="fieldName">
                                        <span>Nome completo</span>
                                      </div>

                                      <InputCheckoutLP
                                        name="receiverName"
                                        disabled={disableInput.receiverName}
                                        type="text"
                                        className="centralize"
                                        value={values.receiverName}
                                        onChange={(e) => {
                                          const { name: _name, value: _value } = e.target;
                                          updateValues(_name, _value);
                                        }}
                                      />
                                    </CheckoutInformation>

                                    <CheckoutInformation className="receiverPhone">
                                      <div className="fieldName">
                                        <span>Telefone/Celular</span>
                                      </div>

                                      <InputCheckoutLP
                                        name="receiverPhone"
                                        disabled={disableInput.receiverPhone}
                                        type="text"
                                        maxLength={15}
                                        onBlur={(e) => {
                                          updateValues(
                                            "receiverPhone",
                                            formatPhoneNumber(e.target.value),
                                          );
                                        }}
                                        onFocus={(e) => {
                                          updateValues(
                                            "receiverPhone",
                                            e.target.value.replace(/\D/g, ""),
                                          );
                                        }}
                                        className="centralize"
                                        value={values.receiverPhone}
                                        onChange={(e) => {
                                          const { name: _name, value: _value } = e.target;
                                          const phone = _value.replace(/\D/g, "");

                                          if (phone.length > 11) return;
                                          updateValues(_name, phone);
                                        }}
                                      />
                                    </CheckoutInformation>
                                  </ReceiverInformation>
                                </ResponsibleReceiving>

                                {(checkout_payload.shipping?.type === "correios" ||
                                  checkout_payload.shipping?.type === "fixed_amount") && (
                                  <>
                                    <LineDivider />

                                    <DeliveryType className="row">
                                      <h2>Tipo de Entrega</h2>

                                      <div className="deliveryTypePrices">
                                        {errorDelivery ? (
                                          <span>Erro ao buscar tipo de entrega</span>
                                        ) : (
                                          showDeliveryValues()
                                        )}
                                      </div>
                                    </DeliveryType>
                                  </>
                                )}
                              </>
                            )}
                          </Address>

                          {showCepInfo === 0 && <></>}
                          {showCepInfo === 2 && (
                            <>
                              <LoaderStyle>
                                <Loader />
                              </LoaderStyle>
                            </>
                          )}
                        </DeliveryAddress>

                        <LineDivider />

                        {checkout_payload.shipping.type !== "correios" &&
                          checkout_payload.shipping.type !== "fixed_amount" && (
                            <>
                              <DeliveryType className="row">
                                <h2>Tipo de Entrega</h2>

                                <div className="deliveryTypePrices">
                                  {checkout_payload.shipping.type === "free" ? (
                                    <span>Frete Grátis</span>
                                  ) : (
                                    <span>Tipo de entrega não identificada</span>
                                  )}
                                </div>
                              </DeliveryType>

                              <LineDivider />
                            </>
                          )}
                      </>
                    )}
                  </>
                )}

                <FormPayment>
                  <h2>Forma de Pagamento</h2>

                  <FormPaymentType>
                    {payment_type.map((type) => {
                      // Se estiver parametrizado pra não utilizar o Pix, não renderiza
                      if (type === "Pix") {
                        if (
                          !config_payload.payments.installment_type?.installment_0 ||
                          !config_payload.payments?.pix_key ||
                          checkout_payload.payment?.recurrent_payment ||
                          checkout_payload.transaction_type === "preauthorization"
                        ) {
                          return;
                        }
                      }

                      return (
                        <InputFormPayment
                          key={type}
                          style={{
                            backgroundColor:
                              transaction_values?.paymentForm === getPaymentValue(type)
                                ? "#cef0ff"
                                : "#fff",
                            display: "flex",
                            justifyContent: "center",
                          }}
                          id={type}
                          onClick={() => {
                            const delivery_values = values.deliveryType;
                            const delivery_option = values.deliveryChoice;
                            const { paymentForm } = transaction_values;
                            const amount = Number(transaction_values.standard_amount);
                            const discounted_amount = amount - Number(transaction_values.discount_pix);

                            const amount_standard_with_ship = String(
                              amount + Number(delivery_values[delivery_option]?.price || ""),
                            );
                            const discount_with_ship = String(
                              discounted_amount + Number(delivery_values[delivery_option]?.price || ""),
                            );

                            // Ao clicar no já selecionado, desseleciona
                            updateTransactionValues(
                              "paymentForm",
                              paymentForm === getPaymentValue(type) ? "" : getPaymentValue(type),
                            );

                            const apply_discount =
                              (paymentForm === "pix" && type === "Pix") || type === "Cartão de crédito";

                            updateTransactionValues(
                              "amount",
                              apply_discount ? amount_standard_with_ship : discount_with_ship,
                            );
                          }}
                        >
                          <span>{type}</span>
                        </InputFormPayment>
                      );
                    })}
                  </FormPaymentType>

                  {/* Tipo de pagamento cartão de crédito */}
                  {transaction_values.paymentForm === "credCard" && (
                    <>
                      <span>Selecione a bandeira do seu cartão de crédito</span>
                      <FlagsContainerRow className="row">
                        {Object.keys(bandeiras).map((bandeira) => {
                          if (
                            transactionMethods.auth &&
                            !checkout_payload.payment?.recurrent_payment &&
                            // (bandeira === "HIPERCARD" || bandeira === "AMEX")
                            bandeira === "HIPERCARD"
                          ) {
                            return;
                          } else {
                            return (
                              <FlagsContainer key={bandeira}>
                                <label>
                                  <CheckoutTypeFlags
                                    style={{
                                      backgroundColor:
                                        transaction_values.authorizerId === getAuthorizerId(bandeira)
                                          ? "#cef0ff"
                                          : "#fff",
                                    }}
                                    id={bandeira}
                                    name="authorizerId"
                                    value={transaction_values.authorizerId}
                                    onClick={() => {
                                      if (
                                        transaction_values.authorizerId === getAuthorizerId(bandeira)
                                      ) {
                                        updateTransactionValues("authorizerId", "");
                                      } else {
                                        updateTransactionValues(
                                          "authorizerId",
                                          getAuthorizerId(bandeira),
                                        );
                                      }
                                    }}
                                  >
                                    <ImgFlag
                                      src={bandeiras[bandeira]}
                                      alt={bandeira}
                                      className="radio__img"
                                    />
                                  </CheckoutTypeFlags>
                                </label>
                              </FlagsContainer>
                            );
                          }
                        })}
                      </FlagsContainerRow>

                      <CardContainer className="row">
                        <CheckoutInformation className="cardNumber">
                          <div className="fieldName">
                            <span>Número do cartão</span>
                          </div>

                          <InputCheckoutLP
                            id="card-number"
                            name="cardNumber"
                            type="text"
                            className="inputCardNumber"
                            placeholder="XXXX XXXX XXXX XXXX"
                            disabled={false}
                            maxLength={19}
                            value={transaction_values.cardNumber}
                            onPaste={() => {
                              setInitialMddValues([25, "Colado"]);
                            }}
                            onChange={(e) => {
                              const { name: _name, value: _value } = e.target;

                              const standardCard = _value.replace(/\D/g, "");

                              // Se estiver selecionado, faz a máscara direto
                              if (transaction_values.authorizerId === "3") {
                                if (standardCard.length === 16) return;

                                const masked = standardCard.replace(
                                  /(\d{0,4})(\d{0,6})(\d{0,5})/,
                                  (_, g1, g2, g3) => {
                                    if (g3) return `${g1} ${g2} ${g3}`;
                                    if (g2) return `${g1} ${g2}`;
                                    return g1;
                                  },
                                );
                                updateTransactionValues(_name, masked);
                              } else {
                                const masked = standardCard.replace(/(.{4})/g, "$1 ").trim();
                                updateTransactionValues(_name, masked);
                              }

                              setInitialMddValues([26, checkCardChanged(standardCard)]);
                            }}
                          />
                        </CheckoutInformation>

                        <CheckoutInformation className="validity">
                          <div className="fieldName">
                            <span>Validade</span>
                          </div>

                          <BoxSelectCheckoutLP>
                            {/* Mês */}
                            <SelectCheckoutPayment
                              name="expiryMonth"
                              value={transaction_values.expiryMonth}
                              onChange={(e) => {
                                const { name: _name, value: _value } = e.target;
                                updateTransactionValues(_name, _value);
                              }}
                            >
                              <option value="" disabled hidden>
                                Mês
                              </option>
                              {months.map((month, i) => (
                                <option key={month} value={String(i + 1).padStart(2, "0")}>
                                  {month}
                                </option>
                              ))}
                            </SelectCheckoutPayment>

                            {/* Ano */}
                            <SelectCheckoutPayment
                              name="expiryYear"
                              value={transaction_values.expiryYear}
                              onChange={(e) => {
                                const { name: _name, value: _value } = e.target;
                                updateTransactionValues(_name, _value);
                              }}
                            >
                              <option value="" disabled hidden>
                                Ano
                              </option>
                              {Array(13)
                                .fill(null)
                                .map(() => getKey())
                                .map((key, i) => (
                                  <option key={key}>{new Date().getFullYear() + i}</option>
                                ))}
                            </SelectCheckoutPayment>
                          </BoxSelectCheckoutLP>
                        </CheckoutInformation>

                        <CheckoutInformation className="cardName">
                          <div className="fieldName">
                            <span>Nome do titular do cartão</span>
                          </div>

                          <InputCheckoutLP
                            id="name-titular"
                            name="cardName"
                            type="text"
                            placeholder="Digite o nome impresso no cartão"
                            className="inputCardName"
                            value={transaction_values.cardName}
                            onChange={(e) => {
                              const { name: _name, value: _value } = e.target;
                              updateTransactionValues(_name, _value);
                            }}
                          />
                        </CheckoutInformation>

                        <CheckoutInformation className="securityCode">
                          <div className="fieldName">
                            <span>CVV</span>
                          </div>

                          <InputCheckoutLP
                            id="security-code"
                            name="securityCode"
                            type="text"
                            className="inputSecurityCode"
                            placeholder="XXX"
                            maxLength={4}
                            value={transaction_values.securityCode}
                            onChange={(e) => {
                              const { name: _name, value: _value } = e.target;
                              const regex = /^[0-9\b]*$/;
                              if (regex.test(_value)) {
                                updateTransactionValues(_name, _value);
                              }
                            }}
                          />
                        </CheckoutInformation>

                        <CheckoutInformation className="parcelNumber">
                          <div className="fieldName">
                            <span>Número de parcelas</span>
                          </div>

                          <SelectOption
                            enable={enableInstallments()}
                            amountValue={transaction_values.amount}
                            updateParcelField="parcels"
                            updateInterestAmountField="interest_amount"
                            installmentValues={values.parcelValues}
                            updateFunction={updateTransactionValues}
                            setMdd={setInitialMddValues}
                            bgColor={config_payload.exhibition?.background_color || "#F1B434"}
                            recurrent={checkout_payload.payment?.recurrent_payment ? true : false}
                            items={arrayParcel(
                              values.parcelValues,
                              config_payload.payments?.installment_type,
                              checkout_payload.payment,
                            )}
                          />
                        </CheckoutInformation>
                      </CardContainer>
                    </>
                  )}

                  {/* Tipo de pagamento PIX */}
                  {transaction_values.paymentForm === "pix" && (
                    <>
                      <DivPix>
                        <PixImg src={pixImg} alt="imagem PIX" />
                        <p>A chave para pagamento será fornecida após a finalização da compra.</p>
                      </DivPix>
                    </>
                  )}

                  {/* Termos de uso */}
                  <div className="col-xl-12">
                    <CheckoutAllowTerms>
                      <input
                        id="allow-terms"
                        name="allowTerms"
                        type="checkbox"
                        checked={values.allowTerms}
                        onChange={(e) => {
                          const { name: _name, checked: _value } = e.target;
                          updateValues(_name, _value);
                        }}
                      />
                      <label htmlFor="allow-terms">
                        Li e concordo com os{" "}
                        <a
                          href="https://www.mrpay.com.br/wp-content/uploads/2023/02/Termos-de-uso.pdf"
                          target="_blank"
                        >
                          <strong>TERMOS DE USO</strong>
                        </a>
                      </label>
                    </CheckoutAllowTerms>
                  </div>
                </FormPayment>

                <LineDivider />

                <DeliveryAddress>
                  <h2>Endereço de cobrança</h2>

                  {!payerAddress && (
                    <>
                      {(checkout_payload.shipping?.type === "correios" ||
                        checkout_payload.shipping?.type === "fixed_amount" ||
                        checkout_payload.shipping?.type === "free") && (
                        <FormBillingAddress>
                          <label>
                            <input
                              className="inputCheck"
                              type="checkbox"
                              id="sameBillingToDelivery"
                              name="sameBillingToDelivery"
                              checked={values.sameBillingToDelivery}
                              onChange={(e) => {
                                // Verifica se está ocorrendo chamada de API ao Correios
                                if (showCepInfo === 2) return;

                                const { name: _name, checked: _value } = e.target;
                                if (_value) sameBillingToDelivery(true);
                                else {
                                  sameBillingToDelivery(false);
                                  if (billingShowCepInfo === 1) setBillingShowCepInfo(0);
                                  if (billingCepError) setBillingCepError(false);
                                }
                                updateValues(_name, _value);
                              }}
                            />
                            <span>Mesmo endereço da entrega</span>
                          </label>
                        </FormBillingAddress>
                      )}
                    </>
                  )}

                  {!values.sameBillingToDelivery && (
                    <>
                      <Address className="row">
                        <CountryCepContainer>
                          <CheckoutInformation className="addressCountry">
                            <div className="fieldName">
                              <span>País</span>
                            </div>

                            <BoxSelectCheckoutLP>
                              <SelectCheckoutLP
                                name="billingCountry"
                                disabled={disableInput.billingCountry}
                                value={values.billingCountry}
                                onChange={(e) => {
                                  const { name: _name, value: _value } = e.target;
                                  updateValues(_name, _value);

                                  if (_value !== "Brasil") {
                                    setBillingShowCepInfo(1);
                                  } else {
                                    setBillingShowCepInfo(0);
                                  }

                                  clearBillingAddressValues(); // Limpa os campos
                                }}
                              >
                                <option>Selecione o país</option>
                                {Object.keys(countries).map((country) => (
                                  <option key={country}>{country}</option>
                                ))}
                              </SelectCheckoutLP>
                            </BoxSelectCheckoutLP>
                          </CheckoutInformation>

                          <CheckoutInformation className="billingCep">
                            <div className="fieldName" style={{ width: "100%" }}>
                              <span>CEP</span>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <InputCheckoutLP
                                style={
                                  billingCepError
                                    ? {
                                        borderColor: "#FF0000",
                                        color: "#FF0000",
                                      }
                                    : {}
                                }
                                placeholder=""
                                inputMode="numeric"
                                name="billingCep"
                                maxLength={9}
                                type="text"
                                className="centralize"
                                disabled={disableInput.billingCep}
                                value={values.billingCep}
                                onChange={async (e) => {
                                  setBillingCepError(false);
                                  const { name: _name, value: _value } = e.target;
                                  const masked = _value.replace(/\D/g, "");

                                  if (values.billingCountry === "Brasil" && masked.length > 8) return;

                                  updateValues(_name, masked);

                                  if (values.billingCountry !== "Brasil") return;

                                  if (_value.replace(/(\D)/g, "").length === 8) {
                                    setBillingShowCepInfo(2);
                                    const { value: _value } = e.target;
                                    const _cep = _value.replace("-", "");
                                    if (_cep.length === 8) {
                                      await searchCep(_cep, testMode)
                                        .then((value) => {
                                          setBillingAddress(value);
                                          setBillingShowCepInfo(1);
                                        })
                                        .catch((error) => {
                                          console.log("[error]", error);
                                          showInformationPopUp({
                                            message: error.response.msgs[0],
                                          });
                                          setBillingCepError(true);
                                          setBillingShowCepInfo(0);
                                        });
                                    }
                                  }
                                }}
                              />
                              {!disableInput.billingCep && (
                                <div
                                  style={{
                                    width: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                  }}
                                >
                                  <img className="questionImg" src={infoQuestion} alt="" />
                                  <a
                                    target="_blank"
                                    href="https://buscacepinter.correios.com.br/app/endereco/index.php"
                                    rel="noreferrer"
                                  >
                                    Não sei o CEP
                                  </a>
                                </div>
                              )}
                            </div>
                          </CheckoutInformation>
                        </CountryCepContainer>

                        {billingShowCepInfo === 1 && (
                          <>
                            <CheckoutInformation className="addressName">
                              <div className="fieldName">
                                <span>Endereço</span>
                              </div>

                              <InputCheckoutLP
                                id="billingAddress"
                                name="billingAddress"
                                type="text"
                                disabled={disableInput.billingAddress}
                                value={values.billingAddress}
                                onChange={(e) => {
                                  const { name: _name, value: _value } = e.target;
                                  updateValues(_name, _value);
                                }}
                              />
                            </CheckoutInformation>

                            <CheckoutInformation className="addressNumber">
                              <div className="fieldName">
                                <span>Número</span>
                              </div>

                              <InputCheckoutLP
                                id="billingAddressNumber"
                                name="billingAddressNumber"
                                type="text"
                                className="centralize"
                                disabled={disableInput.billingAddressNumber}
                                value={values.billingAddressNumber}
                                onChange={(e) => {
                                  const { name: _name, value: _value } = e.target;
                                  updateValues(_name, _value);
                                }}
                              />
                            </CheckoutInformation>

                            <CheckoutInformation className="addressComplement">
                              <div className="fieldName">
                                <span>Complemento</span>
                              </div>

                              <InputCheckoutLP
                                id="billingComplement"
                                name="billingComplement"
                                type="text"
                                disabled={disableInput.billingComplement}
                                value={values.billingComplement}
                                onChange={(e) => {
                                  const { name: _name, value: _value } = e.target;
                                  updateValues(_name, _value);
                                }}
                              />
                            </CheckoutInformation>

                            <CheckoutInformation className="addressDistrict">
                              <div className="fieldName">
                                <span>Bairro</span>
                              </div>

                              <InputCheckoutLP
                                id="billingDistrict"
                                name="billingDistrict"
                                type="text"
                                disabled={disableInput.billingDistrict}
                                value={values.billingDistrict}
                                onChange={(e) => {
                                  const { name: _name, value: _value } = e.target;
                                  updateValues(_name, _value);
                                }}
                              />
                            </CheckoutInformation>

                            <CheckoutInformation className="addressCity">
                              <div className="fieldName">
                                <span>Cidade</span>
                              </div>

                              <InputCheckoutLP
                                id="billingCity"
                                name="billingCity"
                                type="text"
                                disabled={disableInput.billingCity}
                                value={values.billingCity}
                                onChange={(e) => {
                                  const { name: _name, value: _value } = e.target;
                                  updateValues(_name, _value);
                                }}
                              />
                            </CheckoutInformation>

                            <CheckoutInformation className="addressState">
                              <div className="fieldName">
                                <span>Estado</span>
                              </div>

                              {values.billingCountry === "Brasil" ? (
                                <BoxSelectCheckoutLP>
                                  <SelectCheckoutLP
                                    name="billingState"
                                    disabled={disableInput.billingState}
                                    value={values.billingState}
                                    onChange={(e) => {
                                      const { name: _name, value: _value } = e.target;
                                      updateValues(_name, _value);
                                    }}
                                  >
                                    <option>UF</option>
                                    {states.map((state) => (
                                      <option key={state}>{state}</option>
                                    ))}
                                  </SelectCheckoutLP>
                                </BoxSelectCheckoutLP>
                              ) : (
                                <InputCheckoutLP
                                  id="billing-state"
                                  name="billingState"
                                  type="text"
                                  className="internationalState"
                                  placeholder=""
                                  maxLength={2}
                                  value={values.billingState}
                                  onChange={(e) => {
                                    const { name: _name, value: _value } = e.target;
                                    const acronym = _value.replace(/\d/g, "").toUpperCase();
                                    updateValues(_name, acronym);
                                  }}
                                />
                              )}
                            </CheckoutInformation>
                          </>
                        )}
                      </Address>
                      {billingShowCepInfo === 0 && <></>}
                      {billingShowCepInfo === 2 && (
                        <LoaderStyle>
                          <Loader />
                        </LoaderStyle>
                      )}
                    </>
                  )}

                  {/* <LineDivider /> */}
                </DeliveryAddress>

                <LineDivider />

                <Identification className="row">
                  <h2>Identificação</h2>

                  <CheckoutInformation className="identificationName">
                    <div className="fieldName">
                      <span>Nome completo</span>
                    </div>

                    <InputCheckoutLP
                      name="identificationName"
                      disabled={disableInput.identificationName}
                      type="text"
                      placeholder="Digite o seu Nome Completo"
                      className="centralize"
                      value={values.identificationName}
                      onChange={(e) => {
                        const { name: _name, value: _value } = e.target;
                        updateValues(_name, _value);
                      }}
                    />
                  </CheckoutInformation>

                  <CheckoutInformation className="documentNumber">
                    <div className="fieldName">
                      <span>N.° de identificação</span>
                    </div>

                    <InputCheckoutLP
                      name="document_number"
                      disabled={disableInput.document_number}
                      type="text"
                      maxLength={18}
                      onBlur={(e) => {
                        const idPayer =
                          values.billingCountry !== "Brasil"
                            ? e.target.value
                            : formatCpfCnpj(e.target.value);
                        updateValues("document_number", idPayer);
                      }}
                      onFocus={(e) => {
                        updateValues("document_number", e.target.value);
                      }}
                      placeholder="Ex: CPF, CNPJ, SSN..."
                      className="centralize"
                      value={values.document_number}
                      onChange={(e) => {
                        const { name: _name, value: _value } = e.target;
                        const document_number = _value;

                        if (document_number.length > 19) return;
                        updateValues(_name, document_number);

                        if (document_number.length === 11) {
                          setInitialMddValues([32, document_number.replace(/\D/g, "")]);
                        } else {
                          setInitialMddValues([32, ""]);
                        }
                      }}
                    />
                  </CheckoutInformation>

                  <CheckoutInformation className="phone">
                    <div className="fieldName">
                      <span>Telefone</span>
                    </div>

                    <InputCheckoutLP
                      name="phone"
                      disabled={disableInput.phone}
                      type="text"
                      maxLength={15}
                      onBlur={(e) => {
                        updateValues("phone", formatPhoneNumber(e.target.value));
                      }}
                      onFocus={(e) => {
                        updateValues("phone", e.target.value.replace(/\D/g, ""));
                      }}
                      placeholder="Digite o seu Telefone"
                      className="centralize"
                      value={values.phone}
                      onChange={(e) => {
                        const { name: _name, value: _value } = e.target;
                        const phone = _value.replace(/\D/g, "");

                        if (phone.length > 11) return;
                        updateValues(_name, phone);
                      }}
                    />
                  </CheckoutInformation>

                  <CheckoutInformation className="email">
                    <div className="fieldName">
                      <span>E-mail</span>
                    </div>

                    <InputCheckoutLP
                      name="email"
                      disabled={disableInput.email}
                      type="email"
                      placeholder="Digite o seu e-mail"
                      className="centralize"
                      value={values.email}
                      onPaste={() => {
                        setInitialMddValues([33, "Colado"]);
                      }}
                      onChange={(e) => {
                        const { name: _name, value: _value } = e.target;
                        updateValues(_name, _value);
                      }}
                    />
                  </CheckoutInformation>

                  <CheckoutInformation className="emailConfirm">
                    <div className="fieldName">
                      <span>Confirme seu e-mail</span>
                    </div>

                    <InputCheckoutLP
                      name="emailConfirm"
                      disabled={disableInput.emailConfirm}
                      type="email"
                      placeholder="Confirme o seu e-mail"
                      className="centralize"
                      value={values.emailConfirm}
                      onChange={(e) => {
                        const { name: _name, value: _value } = e.target;
                        updateValues(_name, _value);
                      }}
                    />
                  </CheckoutInformation>
                </Identification>
              </InfoContents>

              {/* Box container do Resumo do pedido */}
              <PurchaseCheckout>
                <ReCAPTCHA
                  ref={recaptchaRef}
                  size="invisible"
                  sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                  onChange={(token) => {
                    setIsInvalidToken(!!token);
                  }}
                />
                <PurchaseSummary>
                  <TitleProducts>Resumo da compra</TitleProducts>
                  {"cart" in checkout_payload ? (
                    checkout_payload.cart.items.map((item, key) => (
                      <BoxProductValues key={key}>
                        <div className="productsAndPrices">
                          <h4>{item.product_name}</h4>
                          <h2>{toMoneyFormat(item.product_price)}</h2>
                          {item.quantity > 0 && <h4>Quantidade: {item.quantity}</h4>}
                          {item.description_view && item.product_description && (
                            <ProductDescription reveal={reveal[key]}>
                              <div
                                style={{
                                  display: "flex",
                                  marginTop: "6.5px",
                                  justifyContent: "center",
                                  marginRight: "4px",
                                }}
                              >
                                <AlertImage color={"#00629b"} />
                              </div>
                              <p
                                onClick={() => {
                                  setReveal((old) =>
                                    old.map((value, i) => (i === key ? !value : value)),
                                  );
                                }}
                                title={reveal[key] ? "Clique para minimizar" : "Clique para expandir"}
                              >
                                {item.product_description.split("\r\n").join("\n")}
                              </p>
                            </ProductDescription>
                          )}
                        </div>
                      </BoxProductValues>
                    ))
                  ) : (
                    <></>
                  )}
                  <PurchaseDetails>
                    <div className="textLine">
                      <h2 className="textLeft">Subtotal:</h2>
                      <h3 className="textRight">
                        {"cart" in checkout_payload ? (
                          toMoneyFormat(subtotalValue(checkout_payload))
                        ) : (
                          <></>
                        )}
                      </h3>
                    </div>

                    {checkout_payload.cart?.discount && checkout_payload.cart?.discount?.value !== 0 ? (
                      <div className="textLine">
                        <h2 className="textLeft">Desconto:</h2>
                        <h3 className="textRight">- {toMoneyFormat(discountValue(checkout_payload))}</h3>
                      </div>
                    ) : (
                      <></>
                    )}

                    {transaction_values.paymentForm === "pix" &&
                    config_payload.payments?.discount_for_payment_with_Pix ? (
                      <div className="textLine">
                        <h2 className="textLeft">Desconto (Pix %):</h2>
                        <h3 className="textRight">- {toMoneyFormat(transaction_values.discount_pix)}</h3>
                      </div>
                    ) : (
                      <></>
                    )}

                    {checkout_payload.shipping &&
                      checkout_payload.shipping?.type !== "without_shipping_pick_up" && (
                        <div className="textLine">
                          <h2 className="textLeft">Frete:</h2>
                          <h3 className="textRight">
                            {toMoneyFormat(values.deliveryType[values.deliveryChoice]?.price || "")}
                          </h3>
                        </div>
                      )}

                    {transaction_values.paymentForm === "credCard" &&
                      transaction_values.interest_amount && (
                        <div className="textLine">
                          <h2 className="textLeft">Juros de parcelamento:</h2>
                          <h3 className="textRight">
                            {toMoneyFormat(
                              getInterestValue(
                                transaction_values.interest_amount,
                                transaction_values.amount,
                              ),
                            )}
                          </h3>
                        </div>
                      )}

                    <LineDivider />

                    <div className="totalTextLine">
                      <span className="textLeft">Total:</span>
                      <span className="textRight">
                        {toMoneyFormat(transaction_values.interest_amount || transaction_values.amount)}
                      </span>
                    </div>
                  </PurchaseDetails>
                  <ConfirmBtn
                    type="submit"
                    bgColor={config_payload.exhibition?.background_color || "#F1B434"}
                    letterColor={letterButtonColor}
                  >
                    {circleLoad ? (
                      <CircleLoader width="23" height="23" fill={letterButtonColor} />
                    ) : (
                      <span>Finalizar compra</span>
                    )}
                  </ConfirmBtn>
                  <DivLogoImg>
                    <LogoMrImg src={compraSeguraLogo} />
                  </DivLogoImg>
                </PurchaseSummary>
              </PurchaseCheckout>
            </CheckoutForm>
          </CheckoutLPContainer>
        </Divbackground>
        // aqui começa a condição pra checkout_payload === 0
      )}
      {!IsAlready &&
        ReactDOM.createPortal(<AuthSetup ref={{ form: formRef, input: inputRef }} />, document.body)}
      {/* Pagamento com desafio */}
      {Object.keys(authData).length !== 0 &&
        ReactDOM.createPortal(<AuthChallenger data={authData} ref={challengerRef} />, document.body)}
      {stage === 0 && <></>}
      {stage === 2 && (
        <>
          <NotFound />
        </>
      )}
      {stage === 4 && (
        <span>
          <NotFound />
        </span>
      )}
      {stage === 5 && (
        <span>
          <NotFound />
        </span>
      )}
    </div>
  );
}

export { Link };
